import React from 'react';

class SampleViewRect extends React.Component {

    wellSelected(row, col) {
        this.props.handleSelectRowSample(row, col, this.props.plate.name);
        this.props.handleSelectRowBuffer(row, col, this.props.plate.name);
    }

    wellClick() {
    }

    render() {
        if (this.props.bufferTableRows) {
            let found1 = this.props.bufferTableRows.find(bufferTableRow => {
                return bufferTableRow.plate === this.props.plate.name && bufferTableRow.row === this.props.platerow && bufferTableRow.column === this.props.platecol
            });

            if (found1) {
                return <rect
                    width='50%'
                    x="25%"
                    y="25%"
                    height='50%'
                    style={{
                        fill: '#0097a7',
                        strokeWidth: '3',
                        stroke: this.props.selectedWell === `${this.props.plate.name}:${this.props.platerow}:${this.props.platecol}` ? 'red' : 'rgb(136, 136, 136)'
                    }}
                    onClick={() => {
                        this.wellSelected(this.props.platerow, this.props.platecol);
                        this.wellClick(`${this.props.platecol}${this.props.platecol}`);
                        this.props.handleShowBufferTable();
                    }}
                />
            }
        }

        if (this.props.sampleTableRows) {
            let found2 = this.props.sampleTableRows.find(sampleTableRow => {
                return sampleTableRow.plate === this.props.plate.name && sampleTableRow.row === this.props.platerow && sampleTableRow.column === this.props.platecol
            });

            if (found2) {
                return <rect
                    width='50%'
                    x="25%"
                    y="25%"
                    height='50%'
                    style={{
                        fill: '#66bb6a',
                        strokeWidth: '3',
                        stroke: this.props.selectedWell === `${this.props.plate.name}:${this.props.platerow}:${this.props.platecol}` ? 'red' : 'rgb(136, 136, 136)'
                    }}
                    onClick={() => {
                        this.wellSelected(this.props.platerow, this.props.platecol);
                        this.wellClick(`${this.props.platerow}${this.props.platecol}`);
                        this.props.handleShowSampleTable();
                    }}
                />
            }
        }
        return null;
    }
}

export default SampleViewRect;


// WEBPACK FOOTER //
// ./src/components/saxs/CrystalPlate/SampleViewRect.jsx